
import React from "react";
import Mycelium from "@/components/icons/Mycelium";

const HeroSection = () => {
  return (
    <section className="bg-earth-50 py-16 md:py-24">
      <div className="container">
        <div className="max-w-3xl mx-auto text-center">
          <Mycelium className="h-16 w-16 text-eco-500 mx-auto mb-8" strokeWidth={1} />
          <h1 className="text-4xl md:text-5xl font-bold mb-6 text-eco-800">About Ourcelium</h1>
          <p className="text-xl text-muted-foreground mb-8">
            Connecting communities with sustainable solutions for a better tomorrow
          </p>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
